import { useMemo, useRef, useState } from "react"
import { useParams } from "react-router"
import { useLocation } from "react-router-dom";

import Title from '@base/Title'
import Toast from '@base/Toast'

import CartoesTableView from "@pages/Escola/Cartoes/componentes/CartoesTableView"

import { ProcessoResolver } from "@helpers/ProcessoHelper"

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export const ListagemCartoesIlegiveis = () => {
  const params = useParams();
  const query = useQuery();
  
  const processo = ProcessoResolver(params.processo);
  
  const toastRef = useRef(null)

  const [ horaUltimoRefresh, setHoraUltimoRefresh ] = useState();

  const colunas = [
    { label: 'Objeto Postal', name: 'numeroObjetoPostal', key: false, 
      func: (c, l) => <span style={{cursor: 'pointer', textDecoration: 'underline'}} onClick={() => window.open("../objetosPostais/" + c, "_blank")} >{c}</span>},
    { label: 'Tipo de Ilegibilidade', name: 'ilegibilidade',  key: false },
    { label: 'Nota', name: 'nota', key: false },
    { label: 'Nota Calculada', name: 'notaCalculada', key: false },
  ];

  return (
    <>
      <Toast ref={toastRef} />
      <Title>Listagem de Cartões Ilegíveis</Title>
      <br />

      <CartoesTableView
        refresh={horaUltimoRefresh}
        filtroObjetoPostal={query.get('objetosPostais') ? query.get('objetosPostais') : ""}
        filtroMarcadoComoIlegivel={true}
        permiteDigitarCartao={false}
        permiteDescartarCartao={true}
        aoDescartarCartao={() => setHoraUltimoRefresh(new Date())}
        aoTransferir={() => setHoraUltimoRefresh(new Date())}
        motivosDescarteDisponiveis={
          () => {
            return [
              { value: 'BRANCO', label: 'Em Branco' },
              { value: 'OUTRO', label: 'Outro' }];
          }
        }
        aoRestaurarCartao={() => setHoraUltimoRefresh(new Date())}
        aoMarcarCartaoComoLegivel={(cartao,cartoes, setCartoes) => {
          let cartoesTemp = cartoes.map(c => {
            if(c.id === cartao){
              return null;
            }else{
              return c;
            }
          });
          setCartoes(cartoesTemp.filter(cartao => cartao != null));
        }}
        processo={processo.id}
        colunasAdicionais={colunas}
      />
    </>
  );
}

export default ListagemCartoesIlegiveis;
